import { render } from "./Notifiche10Giorni.vue?vue&type=template&id=24d8e39e&scoped=true"
import script from "./Notifiche10Giorni.vue?vue&type=script&lang=js"
export * from "./Notifiche10Giorni.vue?vue&type=script&lang=js"

import "./Notifiche10Giorni.vue?vue&type=style&index=0&id=24d8e39e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d8e39e"]])

export default __exports__